<template>
  <div>
    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">HSS - Inventory</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <div>
                <b-container class="text-xs text-right">
                  <b-row>
                    <b-col class="text-right">
                      <div class="input-group">
                        <b-input-group>
                          <template #prepend>
                            <base-button size="sm" type="light" disabled>
                              Filter
                            </base-button>
                          </template>
                          <b-form-input id="filter" type="text" v-model="filter" size="sm"
                                        placeholder="Search inventory" v-on:keyup.enter="filterQuery"
                          ></b-form-input>
                          <template #append>
                            <base-button size="sm" type="primary" v-on:click="filterQuery">
                              <i class="fa fa-search"></i>
                            </base-button>
                            <base-button size="sm" type="warning" title="Reload Inventory" v-on:click="reloadPage">
                              <i class="fa fa-recycle"></i>
                            </base-button>
                          </template>
                        </b-input-group>
                      </div>
                      <br>
                    </b-col>
                  </b-row>
                </b-container>

                <b-table
                  head-row-variant="primary"
                  show-empty
                  striped
                  hover
                  @sort-changed="sortingChanged"
                  :items="listItems"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="0">

                  <template #empty="scope">
                    <div v-if="isLoading" class="text-center">
                      <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                    </div>
                    <div v-else class="text-center">
                      <b>No inventory found</b>
                    </div>
                  </template>

                  <template #cell(iccid)="row" class="text-center">
                    <b-link :to="'/hss/profile/?iccid=' + row.value" title="view profile">
                      {{ row.value }} <i class="ni ni-curved-next"></i>
                    </b-link>
                  </template>

                  <template v-slot:cell(action)="row">
                    <base-button v-if="row.item.status!=='Active'" size="sm" type="success" title="Activate" v-on:click="addRecord(row.item['iccid'])"
                                 :hidden="isReadOnlyUser()">
                      <i class="fa fa-plus"></i>
                    </base-button>

                    <base-button v-if="row.item.status==='Active'" size="sm" type="light" title="Activate Disabled" disabled>
                      <i class="fa fa-plus"></i>
                    </base-button>

<!--                    <base-button size="sm" type="warning" title="View Profile" v-on:click="viewRecord(row.item['iccid'])"-->
<!--                                 :hidden="isReadOnlyUser()">-->
<!--                      <i class="ni ni-check-bold"></i>-->
<!--                    </base-button>-->

                    <base-button v-if="row.item.status==='Active'" size="sm" type="danger" title="Terminate" v-on:click="deleteRecord(row.item['iccid'])"
                                 :hidden="isReadOnlyUser()">
                      <i class="fa fa-trash"></i>
                    </base-button>

                    <base-button v-if="row.item.status!=='Active'" size="sm" type="light" title="Terminate Disabled" disabled>
                      <i class="fa fa-trash"></i>
                    </base-button>

                  </template>

                </b-table>
                <br>
                <b-container class="text-xs">
                  <b-row>
                    <b-col class="text-left">{{ resultsFound }}</b-col>
                    <b-col class="text-center">
                      <b-pagination
                        v-if="total"
                        v-model="currentPage"
                        :total-rows="total"
                        :per-page="length">
                      </b-pagination>
                    </b-col>
                    <b-col class="text-right">{{ resultsUpdated }}</b-col>
                  </b-row>
                </b-container>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

    </base-header>

  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import moment from "moment";
import initService from "@/common/api-services/init-service";
import hssDashboardService from "@/common/api-services/hss-dashboard-service";
import ToastVue from '../../Components/Toast.vue';
export default {

  components: {
    RouteBreadCrumb,
    ToastVue
  },

  data() {
    return {
      showAddModal: false,
      showDeleteModal: false,
      showEditModal: false,
      lastQuery: '',
      sortBy: 'iccid',
      sortDesc: false,
      start: 0,
      length: 15,
      total: 0,
      sort: 'iccid asc',
      filter: '',
      listItems: [],
      currentPage: 1,
      resultsFound: '',
      resultsUpdated: '',
      isLoading: false,
      recordUpdating: false,
      fields: [
        {
          key: 'iccid', sortable: true,
        },
        {
          key: 'imsi', sortable: true,
        },
        {
          key: 'msisdn', sortable: true
        },
        {
          key: 'hss_profile', sortable: true
        },
        {
          key: 'hss_subscribername', sortable: true
        },
        {
          key: 'customer', sortable: true
        },
        {
          key: 'status', sortable: true
        },
        {
          key: 'modified', sortable: true
        },
        {
          key: 'action', label: 'Actions'
        }
      ],
      params: ''
    }
  },

  created() {
    this.filterQuery();
  },

  watch: {
    currentPage: {
      handler: function (value) {
        this.currentPage = value;
        if (!this.sort || this.sort === '') this.sort = 'iccid ASC';
        if (!this.currentPage) {
          this.start = '0';
          this.total = '0';
        } else {
            this.start = (this.length * value) - this.length;
        }
        this.filterQuery();
      }
    }
  },
  methods: {

    isReadOnlyUser() {
      return initService.getReadOnlyRole();
    },

    async reloadPage() {
      this.listItems = null;
      await this.filterQuery();
    },

    async filterQuery() {
      this.listItems = null;
      let searchFilter = '{"imsi":"%"}';
      if (this.filter && this.filter !== '') searchFilter = '{"freetext":"%' + this.filter + '%"}';
      if ((!this.currentPage || this.currentPage === '') && this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        await this.loadRecords(searchFilter);
      }
    },

    async sortingChanged(ctx) {
      this.sort = ctx.sortBy + ' ' + (ctx.sortDesc ? 'desc' : "asc");
      if (!this.sort || this.sort === '') this.sort = 'username asc';
      if ((!this.currentPage || this.currentPage === '') && this.currentPage !== 1) this.currentPage = 1;
      await this.filterQuery();
    },

    async loadRecords(searchFilter) {
      if (this.isLoading) {
        console.log('lastQuery is running...');
        return
      }
      this.isLoading = true;
      await hssDashboardService.inventory(this.start, this.length, this.total, this.sort, searchFilter).then((res) => {
        console.log(res);
        this.resultsUpdated = 'Last Updated: ' + moment().format('MM/DD/YYYY hh:mm:ss');
        if (res.data && res.data.hasOwnProperty('message') && res.data.message.hasOwnProperty('result')) {
          this.listItems = res.data.message.result;
          this.total = res.data.message.total;
          this.start = res.data.message.start;
          this.length = res.data.message.length;
          if (this.total > 0) {
            this.resultsFound = this.total + ' record(s) found';
          } else {
            this.resultsFound = '0 record(s) found';
          }
        } else {
          if (!res.data || res.data.message.includes('FAIL')) {
            this.resultsFound = '0 record(s) found due to error. Details: ' + res.data.message;
          } else {
            this.resultsFound = '0 record(s) found';
          }
        }
      }).catch(e=>{
        console.log(e);
      }).finally(x=>{
        this.isLoading = false;
      });
    },

    async addRecord(iccid) {
      this.$router.push({path: `/hss/activate/?iccid=${iccid}`});

    },

    async viewRecord(iccid) {
      this.$router.push({path: `/hss/profile/?iccid=${iccid}`});
    },

    async deleteRecord(iccid) {
      alert('delete '+iccid);
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //setup for alert
      this.$toast({
        component: ToastVue,
        props: {
          description: message
        }
      }, {
        type: variant
      })
    },

  }
}
</script>

<style scoped>
.table thead th {
  background-color: #f1f1f1 !important;
}

.table tbody td {
  border-bottom: 1px solid #c0e0e8 !important;
}

.table thead th {
  background-color: #5e72e4 !important;
  color: white !important;
  background-image: none !important;
  border-spacing: 0px !important;
  border-right: 1px solid #5e72e4 !important;
}

.table tbody td {
  background-color: white !important;
  color: black !important;
  background-image: none !important;
  border-bottom: 1px solid #AAAAAA !important;
}
</style>
